import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Steps } from 'antd';

interface CustomStepperProps {
    steps: { label: string }[];
    activeStep: number;
    hideLabel?: boolean;
    transSteps?: { label: string; title: string }[];
    onChange?: (value: number) => void;
}
const CustomStepper = ({
    steps,
    activeStep,
    hideLabel,
    transSteps,
    onChange
}: CustomStepperProps) => {
    return (
        <>
            <div className='hidden lg:block'>
                {transSteps ? (
                    <div className='w-[150px] mt-2'>
                        <p className=' text-midnightHaze mb-6 text-base'>
                            {steps[activeStep].label}
                        </p>
                        <Steps
                            className=' text-midnightHaze mb-4 text-sm'
                            direction='vertical'
                            current={activeStep}
                            // progressDot
                            items={transSteps}
                            onChange={onChange}
                        />
                    </div>
                ) : (
                    <Stepper activeStep={activeStep} orientation='horizontal'>
                        {steps.map((step) => (
                            <Step key={step.label}>
                                <StepLabel>{step.label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                )}
            </div>

            <div className='lg:hidden'>
                <div className='flex items-center gap-[8px]'>
                    {steps?.map((_, index) =>
                        index <= activeStep ? (
                            <div className='w-[20px] h-[20px] rounded-[50%] flex justify-center items-center bg-appcolorprimary'>
                                <p className='text-sm font-medium text-white'>
                                    {index + 1}
                                </p>
                            </div>
                        ) : (
                            <div className='w-[8px] h-[8px] rounded-[50%] bg-lavender' />
                        )
                    )}
                </div>
                {!hideLabel && (
                    <div className=' border border-0 border-b  border-appcolorfainttwo pb-[16px] pt-[12px]'>
                        <p className='text-ebony text-base leading-6'>
                            {steps[activeStep].label}
                        </p>
                    </div>
                )}
            </div>
        </>
    );
};

export default CustomStepper;
